/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Filter_LabelInputs */



/**
* | output |
* | --- |
* | "Show" |
*
* @param {Team_Filter_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_filter_label = /** @type {((inputs?: Team_Filter_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Filter_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Toon")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher")
	return /** @type {LocalizedString} */ ("Show")
});